import React from "react";

import Icon from "@components/icon";

export default function Lock() {
  return (
    <a className="Lock" href="/support">
      <Icon name="lock" className="Lock-icon" />
    </a>
  );
}
